import { render, staticRenderFns } from "./perfil-persona.vue?vue&type=template&id=8cefe8de&scoped=true&"
import script from "./perfil-persona.vue?vue&type=script&lang=js&"
export * from "./perfil-persona.vue?vue&type=script&lang=js&"
import style0 from "./perfil-persona.vue?vue&type=style&index=0&id=8cefe8de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cefe8de",
  null
  
)

export default component.exports